const DECLARANT_TYPE = {
	A: 'Attorney',
	R: 'Representative'
}

export default DECLARANT_TYPE;